$(function(){
  bsCustomFileInput.init();
});
